module.exports = __webpack_public_path__ + "static/media/taste.855918aa.svg";